import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    uploadUrl: String,
    minimal: Boolean
  }

  async connect() {
    // Wait for Redactor to be available from global scope
    if (typeof window.Redactor === 'undefined') {
      console.error('Redactor is not loaded. Make sure redactor.js is included in the page.')
      return
    }

   console.log("HELLO!");
    const uploadUrl = this.uploadUrlValue

    // Get CSRF token for Rails
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    // Redactor configuration following official docs
    const config = {
      minHeight: '400px',
      buttons: {
        addbar: ['text', 'heading', 'image', 'table', 'embed', 'line']
      },
      toolbar: true
    }

    // Only add image upload if URL is provided
    if (uploadUrl) {
      config.image = {
        upload: uploadUrl,
        url: true,
        name: 'file'
      }

      // Add CSRF token as additional POST data
      if (csrfToken) {
        config.image.data = {
          authenticity_token: csrfToken
        }
      }
    }

    console.log('Redactor config:', config)

    // Initialize Redactor
    this.redactor = window.Redactor(this.element, config)
    console.log('Redactor initialized:', this.redactor)
  }

  disconnect() {
    if (this.redactor && this.redactor.app) {
      this.redactor.app.stop()
    }
  }
}
